import TenderDetail from './TenderDetail';

export default TenderDetail;
